import { createContext, useContext } from 'react';
import { type PublicFieldsProps } from '../types/public-props';

export const FieldPropsContext = createContext<PublicFieldsProps | null>(null);

export function useFieldProps<T extends PublicFieldsProps>(): T {
  const context = useContext(FieldPropsContext);

  if (context === null) {
    throw new Error('useFieldProps must be used within a FieldPropsProvider');
  }

  return context as T;
}
